module.exports = {
	"_args": [
		[
			{
				"raw": "websocket@^1.0.24",
				"scope": null,
				"escapedName": "websocket",
				"name": "websocket",
				"rawSpec": "^1.0.24",
				"spec": ">=1.0.24 <2.0.0",
				"type": "range"
			},
			"/Users/shagul/dev/medpro/medpro-frontend/node_modules/@stomp/stompjs"
		]
	],
	"_from": "websocket@>=1.0.24 <2.0.0",
	"_id": "websocket@1.0.26",
	"_inCache": true,
	"_location": "/websocket",
	"_nodeVersion": "10.0.0",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/websocket_1.0.26_1524784128055_0.2769635769636831"
	},
	"_npmUser": {
		"name": "theturtle32",
		"email": "theturtle32@gmail.com"
	},
	"_npmVersion": "5.6.0",
	"_phantomChildren": {},
	"_requested": {
		"raw": "websocket@^1.0.24",
		"scope": null,
		"escapedName": "websocket",
		"name": "websocket",
		"rawSpec": "^1.0.24",
		"spec": ">=1.0.24 <2.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"/@stomp/stompjs"
	],
	"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.26.tgz",
	"_shasum": "a03a01299849c35268c83044aa919c6374be8194",
	"_shrinkwrap": null,
	"_spec": "websocket@^1.0.24",
	"_where": "/Users/shagul/dev/medpro/medpro-frontend/node_modules/@stomp/stompjs",
	"author": {
		"name": "Brian McKelvey",
		"email": "brian@worlize.com",
		"url": "https://www.worlize.com/"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"debug": "^2.2.0",
		"nan": "^2.3.3",
		"typedarray-to-buffer": "^3.1.2",
		"yaeti": "^0.0.6"
	},
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^1.0.0",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^2.0.4",
		"jshint": "^2.0.0",
		"jshint-stylish": "^2.2.1",
		"tape": "^4.0.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"dist": {
		"integrity": "sha512-fjcrYDPIQxpTnqFQ9JjxUQcdvR89MFAOjPBlF+vjOt49w/XW4fJknUoMz/mDIn2eK1AdslVojcaOxOqyZZV8rw==",
		"shasum": "a03a01299849c35268c83044aa919c6374be8194",
		"tarball": "https://registry.npmjs.org/websocket/-/websocket-1.0.26.tgz",
		"fileCount": 30,
		"unpackedSize": 161464,
		"npm-signature": "-----BEGIN PGP SIGNATURE-----\r\nVersion: OpenPGP.js v3.0.4\r\nComment: https://openpgpjs.org\r\n\r\nwsFcBAEBCAAQBQJa4lwBCRA9TVsSAnZWagAAUUAP/2lAO8BvCFbbT8Zww3ZE\ny8D467tVMN/zCZ5AuUxktg1Gdjr3zVD7JUs7KBwF+DOhQpJ9pwz8EioRJDLX\nwUOe79ylj/SdT7iYin1AwKuRqaWNkTP2IqMMRM2pIO/znZ397h0mC9qXW08J\nuVP44uKoQbtY9+WjjbMMroKd4VVL70fYuJOzZ9BFp3XlPLwSIZ6BzAuDS69e\noo9fYzsGDbGceFL+YNw/xMlahcj3gaVIIfuU04Oq4sAEhouhjNyFVtNyKhIr\n4oMbCwrirxJUrliDw0LVlUxFNkU3YZzZe8SHrnWyIhf7INlVbqrgZ1B8I96q\nT/6hTW2FGnnYFQ6Vv/wBXN4n2YA3NHPcHuqy6IO4TiO52ZAc00cbHvwRNY1q\nDImrnhz+0HcC5/Be57dZS2flfNpAJhuaNiVKpzyhICsvcZpOBDb5pzMdN85h\nV47vgS92SHC9LOxMYNSO8HHu49sBlIv0PLsPncv3fOsXoZPdZsrc9NR8L1lz\nErph7K8Ao7q4J6dd8Tph+Xsm6oQBQ2m5F0ckAQwj90O1hLTU8NRoWro4VeAs\nDo8Evq77m7HhDP0tHAS2ahnGn+fiZK5OtedhZqhDHYAB3Djc/FDhwDiKR2zD\nbEicXTuG/z0dwxQv6kCoK6Msz4d1WDptc6EoYSneUxYADUqLLkG15uI0OrgP\nDJB0\r\n=XLWw\r\n-----END PGP SIGNATURE-----\r\n"
	},
	"engines": {
		"node": ">=0.10.0"
	},
	"gitHead": "0b3d4a5eb253132b2219f6f22a420bfe4680e26a",
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"maintainers": [
		{
			"name": "theturtle32",
			"email": "brian@worlize.com"
		}
	],
	"name": "websocket",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit"
	},
	"version": "1.0.26"
};


//////////////////
// WEBPACK FOOTER
// ./~/websocket/package.json
// module id = 1266
// module chunks = 0